import DatePicker from 'react-toolbox/lib/date_picker';
export default DatePicker;



// WEBPACK FOOTER //
// ./src/components/common/material/DatePicker.js